export enum DVAccountType {
    Kurumsal = 2,
    Bireysel = 1,
    Yurtdışı = 0
}